<hlm-dialog [state]="state()" (closed)="onCancel()">
  <hlm-dialog-content
    *brnDialogContent="let ctx"
    class="w-[min(48rem,calc(100vw-2rem))] md:w-[min(48rem,calc(100vw-2rem))] max-w-none min-w-0 h-[700px] max-h-[90vh] flex flex-col"
  >
    <app-wizard-dialog-header
      eyebrow="Katalog · Speicher"
      [title]="computedTitle()"
      [steps]="wizardSteps()"
      [showTimeline]="config().showTimeline !== false && totalSteps() > 1"
      (stepJump)="goToStep($event)"
    />

    <!-- Step Content -->
    <div hlmSeparator class="my-2"></div>
    <div class="flex-1 py-4 relative w-full min-h-0">
      <div class="h-full w-full transition-all duration-300 ease-in-out overflow-hidden">
        <div class="h-full overflow-y-auto animate-in fade-in-50 duration-300 px-1">
          <app-step-lead [text]="currentLead()" />

          <form [formGroup]="storageForm">
            <!-- Step 1: Storage Details -->
            @if (currentStep() === 1) {
              <div class="flex flex-col gap-5">
                <app-suffix-input
                  label="Name"
                  inputType="text"
                  formControlName="name"
                  required
                  [errorText]="storageForm.get('name')?.invalid && storageForm.get('name')?.touched ? 'Name ist erforderlich (min. 3 Zeichen)' : null"
                />
                <app-suffix-input
                  label="Kapazität"
                  suffix="kWh" [decimals]="1"

                  formControlName="capacity"
                  required
                  [errorText]="storageForm.get('capacity')?.invalid && storageForm.get('capacity')?.touched ? 'Kapazität muss mindestens 0,1 kWh betragen' : null"
                />
                <app-suffix-input
                  label="Preis"
                  suffix="€" [decimals]="2"

                  formControlName="price"
                  required
                  [errorText]="storageForm.get('price')?.invalid && storageForm.get('price')?.touched ? 'Preis ist erforderlich und muss mindestens 0 sein' : null"
                />
              </div>
            }

            <!-- Step 2: Costs & Confirm -->
            @if (currentStep() === 2) {
              <div class="flex flex-col gap-6">
                <app-summary-section title="Speicher" (edit)="jumpToStep(1)">
                  <app-summary-row label="Name" [value]="storageForm.get('name')?.value || '—'" />
                  <app-summary-row label="Kapazität" [value]="(storageForm.get('capacity')?.value | number: '1.1-1') + ' kWh'" mono />
                  <app-summary-row label="Preis" [value]="(storageForm.get('price')?.value | number: '1.2-2') + ' €'" mono />
                </app-summary-section>
                <p class="text-xs text-muted-foreground">
                  Überprüfen Sie die Angaben und klicken Sie auf „{{ computedSubmitButtonText() }}", um den Speicher zu speichern.
                </p>
              </div>
            }
          </form>

          <!-- Error Message -->
          @if (error()) {
            <div class="mt-4 px-3.5 py-3 flex items-start gap-2.5 bg-destructive/10 border border-destructive/20 rounded-lg">
              <p class="text-sm text-destructive">{{ error() }}</p>
            </div>
          }
        </div>
      </div>
    </div>

    <div hlmSeparator></div>
    <app-wizard-dialog-footer
      [currentStep]="currentStep()"
      [totalSteps]="totalSteps()"
      [isFirstStep]="isFirstStep()"
      [isLastStep]="isLastStep()"
      [canProceed]="canProceedFromCurrentStep()"
      [isSubmitting]="isSubmitting()"
      [submitLabel]="computedSubmitButtonText()"
      (back)="prevStep()"
      (next)="nextStep()"
      (submit)="onSubmit(ctx)"
    />
  </hlm-dialog-content>
</hlm-dialog>
